/**
 * apps/web :: pass :: screens/rulePack.routes
 *
 * Self-registering route descriptors for the offline rule pack + emergency
 * card screens (ROADS-569 W1.C2/C6). Pushed into the pass router so the
 * `/pass/rules` and `/pass/emergency` paths mount without a shared edit.
 */
import type { PassRouteDescriptor } from '../routeDescriptor'
import RulePack from './RulePack'
import EmergencyCard from './EmergencyCard'

export const rulePackRoutes: PassRouteDescriptor[] = [
  { path: 'rules', element: <RulePack /> },
  { path: 'emergency', element: <EmergencyCard /> },
]
